import { Checkbox, Panel } from 'react-bootstrap';
import { ISelectedLogisticsProvider } from './models';

interface IProps {
    logisticsProviderList: ISelectedLogisticsProvider[],
    onChange: (id: number) => void,
}

const LogisticsProviders = (props: IProps) => {
    return (
        <Panel>
            <Panel.Heading>Logistics Providers</Panel.Heading>
            <Panel.Body>
                <div style={{ paddingLeft: 10 }}>
                    {props.logisticsProviderList.map(lp =>
                        <Checkbox key={'lp-' + lp.id} inline value={lp.id} checked={lp.selected} onClick={() => props.onChange(lp.id)}>{lp.description}</Checkbox>
                    )}
                </div>
            </Panel.Body>
        </Panel>
    );
}

export default LogisticsProviders;